<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog', false)" @keydown.esc="$emit('updateDialog', false)" max-width="700px" transition="dialog-bottom-transition">
      <v-card>
        <v-form>
          <v-card-title>
            <span class="headline">Validar diferencias</span>
          </v-card-title>

          <v-card-text>
            <v-data-table :headers="headers" :items="list" :loading="loading" loading-text="Cargando...">
              <template v-slot:item="{ item }">
                <tr :class="hasDifference(item) ? 'bg-warning-lighten' : ''">
                  <td>{{ item.product.sku }}</td>
                  <td>{{ item.product.name }}</td>
                  <td>{{ item.expected_amount }}</td>
                  <td>{{ item.base_amount_received }}</td>
                  </tr>
              </template>
            </v-data-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text @click="validate">Validar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { asnService } from "@/libs/ws/asnService";

export default {
  components: {},
  mixins: [],
  props: {
    dialog: Boolean,
    asn: { Type: Object, default: null },
  },
  data() {
    return {
      list: [],
      loading: false,
      headers: [
        { title: "SKU", key: "product.sku" },
        { title: "Producto", key: "product.name" },
        { title: "Cantidad esperada", key: "expected_amount" },
        { title: "Cantidad recibida", key: "base_amount_received	" },
      ],
    };
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.getSummary();
      }
    },
  },
  mounted() {},
  methods: {
    hasDifference(item) {
      const expected = parseFloat(item.expected_amount) || 0;
      const received = parseFloat(item.base_amount_received) || 0;
      return expected !== received;
    },
    getSummary() {
      if(this.loading) return;
      this.loading = true;
      asnService.getSummary({ id: this.asn.id }).then((response) => {
        if(response.status === true) {
          this.list = response.result;
        }else{
          this.$toast.error(response.msg);
        }
      })
      .finally(() => {
        this.loading = false;
      });
    },

    validate(){ 
      if(this.loading) return;
      
      this.loading = true;
      asnService.validateDifferences({ asn_id: this.asn.id })
        .then((response) => {
          if(response.status === true) {
            this.toast.success(response.msg);
            this.$emit('updateDialog', false);
            this.$emit('loadList', asnService);
          } else {
            this.toast.error(response.msg);
          }
        })
        .catch((error) => {
          this.toast.error('Error al validar las diferencias');
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
};
</script>
<style scoped>
.bg-warning-lighten {
  background-color: #fff3cd !important;
}

.bg-warning-lighten:hover {
  background-color: #ffe69c !important;
}
</style>